enum PathEnum {
    PASSWORD_SET = "/ui/pwd/set",
    OTP = "/ui/pwd/set/otp",
    ERROR = "/ui/pwd/set/error",
    PHONE = "/ui/pwd/set/phone",
    VERIFY_PHONE = "/ui/pwd/set/verifyPhone",
    RESULT = "/ui/pwd/set/result"
}

export default PathEnum;
